export default __webpack_public_path__ + "static/media/featuresPayment.3b9ff33b.svg";